/**
 * Demo-mode flags.
 *
 * Set `VITE_DEMO_MODE=true` in frontend/.env to turn the whole app into a
 * public sandbox: shows the demo banner and the quick-sign-in panel. Pair it
 * with `DEMO_MODE=true` in backend/.env so payments are always simulated.
 */
export const DEMO_MODE = import.meta.env.VITE_DEMO_MODE === 'true';

/** Show the quick-login panel in demo builds AND in local dev. */
export const SHOW_DEMO_LOGINS = DEMO_MODE || import.meta.env.DEV;

export const DEMO_PASSWORD = 'Demo!Password1';
export const DEMO_ACCOUNTS = [
  { role: 'Buyer',  name: 'Bob Buyer',    email: 'bob@souqli.test' },
  { role: 'Seller', name: 'Alice Seller', email: 'alice@souqli.test' },
  { role: 'Admin',  name: 'Souqli Admin', email: 'admin@souqli.test' },
] as const;
